export const RESULTS_UPDATE_EVENT = "plp/results-update";
export const CLEARANCE = "Clearance";
